<modal-container
  #modal
  [headerIconClass]="'far-file-export'"
  [headerTitle]="headerTitle"
  [isExtraLargeModal]="true"
  (hide)="onHideChildModal()"
>
  <ng-container class="modal-button-show">
    <btn
      [label]="'exports'"
      [title]="'exports' | translate"
      [classes]="['btn-third', 'float-right', 'me-2']"
      [icon]="'far-list-alt'"
      [btnType]="'button'"
      [dataCyAttribute]="'exports'"
      (click)="showChildModal()"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="container-fluid ps-0 pe-0">
      <form-row-select
        [label]="'type'"
        [options]="queryTypesOptions.data()"
        [model]="selectedType()"
        (modelChange)="selectedTypeChanged($event)"
        [dataCyAttribute]="'export-types-select'"
      ></form-row-select>

      <app-base-listing
        [listName]="'exports'"
        [exportsEntity]="entity()"
        [query]="queryExports"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content"> </ng-container>
</modal-container>
